<template>
  <div class="newsWrap">
    <!-- header -->
    <Header />

    <!-- news -->
    <div class="news">
      <div class="news_one clearfix" v-for="(item, index) in list" :key="index">
        <router-link :to="{name: 'Show', params: {type: 'news', id: item.id}}">
          <dl class="news_left">
            <dt>{{item.name}}</dt>
            <dd>
              <span>{{item.releaseTime}}</span>
            </dd>
            <dd>
              {{item.content}}
              <!-- <p v-for="(remark, i) in item.content.split('。')" :key="i">
                {{remark}}。
              </p> -->
            </dd>
          </dl>
          <div class="news_right">
            <img :src="origin + item.imgUrl" :alt="item.name" width="601" height="403" />
          </div>

          <dd
            class="news_wx"
            @mousemove="qrcodeShow = true"
            @mouseout="qrcodeShow = false"
          >
            <i class="iconfont icon-weixin"></i>
            <!-- 二维码 -->
            <div class="qrcode" v-if="qrcodeShow">
              <img :src="qrcodeImg" :alt="item.name" />
            </div>
          </dd>
        </router-link>
      </div>

      <!-- 分页 -->
      <Page :total="totalCount" :page-size="pageSize" @on-change="pagination" />
    </div>

    <!-- news_mobile -->
    <div class="news_mobile">
      <dl v-for="(item, index) in list" :key="index">
        <router-link :to="{name: 'Show', params: {type: 'news', id: item.id}}">
          <dt><img :src="origin + item.imgUrl" :alt="item.name" /></dt>
          <dt>{{item.name}}</dt>
          <dd>
            <span>{{item.releaseTime}}</span>
          </dd>
          <dd>
            <!-- {{item.content}} -->
            <p v-for="(remark, i) in item.content.split('。')" :key="i">
              {{remark}}。
            </p>
          </dd>
        </router-link>
      </dl>
    </div>

    <!-- footer -->
    <Footer />
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { NewsFeed, AllNewsFeed } from '@/api/http';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Vue from 'vue';
import { Page } from 'iview';
Vue.component('Page', Page);

export default {
  name: 'contact',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      origin: '',
      qrcodeShow: false,
      pageNo: 1, // 默认显示第1页
      newsImg1: require('@/assets/images/news1.png'),
      qrcodeImg: null,
      totalCount: 0,  // 总条数
      pageSize: 3, // 当前页显示条数
      list: []
    };
  },
  created() {
    // 生成二维码
    this.setQrcode();
    // 接口渲染
    if(this.mobileDevice()) {
      // 移动端无分页，显示全部
      // this.newsFace(this.pageNo, 100);
      this.getAllNewsFeed();
    }else{
      this.newsFace(this.pageNo, this.pageSize);
    }
  },
  methods: {
    // 生成二维码
    setQrcode() {
      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 1,
        color: {
          dark: '#b89058',
          light: '',
        },
      };

      // 将当前页的链接获取并赋值
      QRCode.toDataURL(location.href, opts)
        .then((url) => {
          // console.log(url);
          this.qrcodeImg = url;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 数据接口
    newsFace(page, pageSize) {
      NewsFeed({
        "pageNo": page,  // 显示第几页
        "pageSize": pageSize  // 当前页显示条数
      })
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.totalCount = res.data.count;
        this.list = res.data.list;
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 获取所有新闻
    getAllNewsFeed() {
      AllNewsFeed()
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.list = res.data;
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 分页
    pagination(page) {
      // console.log(page)
      this.newsFace(page, this.pageSize);
    },

    // 判断移动设备
    mobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/news';
</style>
